/**
 * 用户
 */

import { getUrlParams } from '@/utils/util'
import {apiLogin, apiKefuDetail} from '@/api/app'


// State
const state = {
    token: '',
    userInfo: {},
    messageUserId: '' // 聊天用户ID
}


// Mutations
const mutations= {
    // 设置用户信息
    SET_USER_INFO: (state, data) => {
        state.userInfo = data;
    },

    SET_TOKEN: (state, token) => {
        state.token = token
    },

    // 清除用户信息
    clearUserInfo: (state) => {
        state.userInfo = {};
    },
    
    // 设置聊天用户ID
    SET_MESSAGE_USER_ID: (state, userId) => {
        state.messageUserId = userId
    }
}


// Actions
const actions = {
    login({commit}, form) {
        return new Promise((resolve, reject) => {
            apiLogin(form).then(data => {
                commit('SET_TOKEN', data)
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    },

    getUserInfo({commit}) {
        return new Promise((resolve, reject) => {
            apiKefuDetail().then(data => {
                commit('SET_USER_INFO', data)
                resolve(data)
            }).catch(err => {
                // reject(err)
            })
        })
    },

    logout({commit}) {
        return new Promise((resolve, reject) => {
            commit('SET_TOKEN', '')
            commit('clearUserInfo')
            resolve()
        })
    },
    
    getMessageUserId({commit}) {
        return new Promise((resolve, reject) => {
            const option = getUrlParams()
            const form = {
                store_id: option.store_id,
                user_id: option.user_id,
                platform_id: option.platform_id,
                application_id: option.application_id,
                mobile: option.mobile
            }
            apiLogin(form).then(data => {
                console.log(data, '获取messageUserId成功')
                commit('SET_MESSAGE_USER_ID', data)
                commit('SET_TOKEN', data)
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    }

}


const user = {
    state,
    mutations,
    actions
}

export default user
